import { useRouter } from "@/shared/utils/hooks/useRouter";

interface HeaderProps {
  title: string;
}
const Header = (props: HeaderProps) => {
  const { navigate } = useRouter();
  const { title } = props;
  return (
    <header
      className="d-flex align-items-center justify-content-center"
      style={{ borderBottom: "1px solid #deaa4f" }}
    >
      <a onClick={() => navigate(-1)} className="back">
        <i className="fa-solid fa-chevron-left"></i>
      </a>
      <h6 className="title m-0">{title}</h6>
    </header>
  );
};

export default Header;
